import { getApiClient } from '../../../stores'
import { listAll } from '../../../utils'
import type { BotSummary } from '../types'

export async function listBots(workspaceId: string): Promise<BotSummary[]> {
  return listAll(getApiClient({ workspaceId }).listBots, {}, ({ bots }) => bots).then((bots) =>
    bots.filter((bot) => bot.tags.deleted !== 'true' && bot.type !== 'desk' && bot.tags.desk !== 'managed')
  )
}

export async function getBot({ workspaceId, botId }: { workspaceId: string; botId: string }) {
  const { bot } = await getApiClient({ workspaceId }).getBot({ id: botId })
  return bot
}

type UpdateBotParams = {
  workspaceId: string
} & Parameters<ReturnType<typeof getApiClient>['updateBot']>['0']
export async function updateBot({ workspaceId, ...props }: UpdateBotParams) {
  const { bot } = await getApiClient({ workspaceId }).updateBot({ ...props })
  return bot
}

export async function listBotApiKeys({ botId, workspaceId }: { botId: string; workspaceId: string }) {
  const { baks } = await getApiClient({ workspaceId }).listBotApiKeys({ botId })
  return baks
}

export async function createBotApiKey({
  workspaceId,
  botId,
  note,
}: {
  workspaceId: string
  botId: string
  note: string
}) {
  return getApiClient({ workspaceId }).createBotApiKey({ note, botId })
}

export async function deleteBotApiKey({ workspaceId, id }: { workspaceId: string; id: string }) {
  return getApiClient({ workspaceId }).deleteBotApiKey({ id })
}
